import { usePersistDataOnStore } from '@hooks/usePersistDataOnStore';
import { useAppDispatch, useAppSelector } from '@store/configureStore';
import { initialState } from '@store/settings/initialStates';
import { loadSettings } from '@store/settings/reducer';
import { selectSettings } from '@store/settings/selectors';
import { type SettingState } from '@store/settings/types';
import { setTheme } from '@utils/theme/setTheme';
import { type PropsWithChildren, useCallback, useEffect } from 'react';

const SETTINGS_KEY = 'PANTHOR_CAPEX_SETTINGS';

const SettingProvider = ({
  children,
  delay = 500,
}: PropsWithChildren<{ delay?: number }>) => {
  const settings = useAppSelector(selectSettings);
  const dispatch = useAppDispatch();

  const handleInitializeData = useCallback(
    (newSettings: SettingState) => {
      dispatch(loadSettings(newSettings));
    },
    [dispatch],
  );

  usePersistDataOnStore({
    data: settings,
    initialData: initialState,
    delay,
    key: SETTINGS_KEY,
    initializeData: handleInitializeData,
  });

  useEffect(() => {
    setTheme(settings.theme);
  }, [settings.theme]);

  return children;
};

export { SettingProvider };
